// ----------------------------------------------
//                 Helper functions
// ----------------------------------------------

// Data Attribute Selection
function selectByBehaviour(selector) {
    return '[data-behaviour="' + selector + '"]';
}

function selectDataString(attribute, selector) {
    return '[data-' + attribute + '="' + selector + '"]';
}


// Don't act on absent elements
jQuery.fn.exists = function(func) {
    if (this.length > 0) {
        func.apply(this);
    }
    return this;
};

// Count decimals
Number.prototype.countDecimals = function () {
    if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
    return Number(this.toString().split(".")[1].length) || 0;
};

// Add commas to number
function numberWithCommas(val) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// Number is even
function isEven(n) {
    return n % 2 === 0;
}
// Number is odd
function isOdd(n) {
    return Math.abs(n % 2) == 1;
}

// Round numbers to two decimals
function roundToTwo(num) {
    return +(Math.round(num + "e+2")  + "e-2");
}

// Convert time - hh:mm:ss or mm:ss to seconds
function hmsToSecondsOnly(str) {
    var p = str.split(':'),
        s = 0, m = 1;

    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }

    return s;
}

// Convert time - seconds to hh:mm:ss
function secondsToHms(totalSeconds) {
    var hours, minutes, seconds;

    hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    minutes = Math.floor(totalSeconds / 60);
    seconds = totalSeconds % 60;

    if (minutes === 0) minutes = '00';
    if (seconds === 0) seconds = '00';

    if (String(minutes).length == 1) minutes = '0' + minutes;
    if (String(seconds).length == 1) seconds = '0' + seconds;

    if (hours !== 0) {
        return hours + ':' + minutes + ':' + seconds;
    }
    else {
        return minutes + ':' + seconds;
    }
}

function secondsToMinutes(totalSeconds) {
    var hours, minutes, seconds;

    minutes = Math.floor(totalSeconds / 60);
    seconds = totalSeconds % 60;

    return minutes;
}


function convertArrayToNumbers(array) {
    var i;
    for (i in array) {
        array[i] = parseFloat(array[i]);
    }
    return array;
}


// Scrolling
function scrollPageTo(position) {
    win.scrollTop(position);
}

function animatedScrollPageTo(position, duration, callback) {
    if (Math.floor(position) != win.data('scrollPosition')) {
        if (!duration) {
            duration = Math.abs((position - win.data('scrollPosition')));

            if (duration < 350) {
                duration = 350;
            }
        }

        if (win.data('scrolling') !== true) {
            win.data('scrolling', true);

            animatedScrollTo(
                document.scrollingElement,
                position,
                duration,
                function() {
                    win.data('scrolling', false);

                    if (typeof callback === 'function') {
                        callback();
                    }
                }
            );
        }
    }
    else {
        if (typeof callback === 'function') {
            callback();
        }
    }
}

// Closest match of a number in an array
function closestMatch(num, arr) {
    var curr = arr[0];
    var diff = Math.abs (num - curr);
    for (var val = 0; val < arr.length; val++) {
        var newdiff = Math.abs (num - arr[val]);
        if (newdiff < diff) {
            diff = newdiff;
            curr = arr[val];
        }
    }
    return curr;
}

// Detect transition event name
function whichTransitionEndEvent() {
    var transitionEndEventNames = {
        'transition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        'MozTransition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd'
    };

    return transitionEndEventNames[Modernizr.prefixed('transition')];
}

function whichAnimationEndEvent() {
    var animationEndEventNames = {
        'WebkitAnimation': 'webkitAnimationEnd',
        'OAnimation': 'oAnimationEnd',
        'msAnimation': 'MSAnimationEnd',
        'animation': 'animationend'
    };

    return animationEndEventNames[Modernizr.prefixed('animation')];
}

// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());
